import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-investment-asset-intangible-list',
  templateUrl: './investment-asset-intangible-list.components.html',
})
export class InvestmentAssetIntangibleListComponent { }
